import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const EMPCounter = ({ count, testId }) => {
  return (
    <Box
      component="div"
      data-testid={testId}
      sx={(theme) => ({
        display: "inline-block",
        borderRadius: 400,
        minWidth: "28px",
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.primary.contrastText,
      })}
    >
      <Typography variant="body2" component="span">
        {count}
      </Typography>
    </Box>
  );
};

EMPCounter.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
};

export default EMPCounter;
